module.exports = __webpack_public_path__ + "af9adcccb6ddb2d3dc3edc46af8045b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/heart.png
// module id = 767
// module chunks = 0